import React, { useEffect, useRef, useState } from "react";
import Widgets from "../../../widgets";
import strings from "../../../utils/strings";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getNationalIdCountries, getNationalIdList, postNationalIdCategory } from "../../../modules/NationalIdCategory/NationalIdThunk";
import { resetNewCategory } from "../../../modules/NationalIdCategory/NationalIdSlice"; // Ensure resetNewCategory is imported
import ToastPopup from "../../../widgets/Toast/toastPopup";
import "./AddNationalId.css"; // Custom CSS for styling the dropdown

function AddNationalIdList({ setSelectedView }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { allNationalId, allNationalIdErr } = useSelector((state) => state.nationalId);
  const { countries, newCategoryErr, loading, newCategorySuccess } = useSelector((state) => state.nationalId);
  const [nationality, setNationality] = useState(""); // Holds the selected country's _id
  const [categoryTitle, setCategoryTitle] = useState(""); // Holds the title for the national ID category
  const [categoryTitlevi, setCategoryTitlevi] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false); // State to manage dropdown open/close
  const selectedLanguage = useSelector((state) => state.language.language);
  const dropdownRef = useRef(null);
  const options = countries?.map((country) => country.name) || [];

  useEffect(() => {
    dispatch(getNationalIdList());
  }, [selectedLanguage]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    // Fetch the countries when the component mounts
    dispatch(getNationalIdCountries());
  }, [dispatch]);

  useEffect(() => {
    // If the form was successfully submitted, show success message and redirect to nationalIdList
    if (newCategorySuccess) {
      ToastPopup.success(t("successMsg")); // Show success message
      setSelectedView("nationalIdList"); // Redirect to nationalIdList
      dispatch(resetNewCategory()); // Reset the form state after successful submission
    }
  }, [newCategorySuccess, setSelectedView, dispatch, t]);

  // Handle dropdown toggle
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // Handle dropdown option selection
  const handleSelectCountry = (countryId) => {
    setNationality(countryId);
    setDropdownOpen(false);
  };

  // Handle form submission
  const handleSubmit = () => {
    if (!categoryTitle) {
      ToastPopup.error(t("plsEntIdTypeen"));
      return;
    }
    if (!categoryTitlevi) {
      ToastPopup.error(t("plsEntIdTypevi"));
      return;
    }
    if (!nationality) {
      ToastPopup.error(t("plsSelIdCat"));
      return;
    }
    const newCategoryData = {
      title: {
        en: categoryTitle,
        vi: categoryTitlevi,
      },
      country: nationality, // Send the selected country's _id
    };
    if (isDuplicateTitle === true) {
      ToastPopup.error(t("idAlreadyExists"));
    } else {
      dispatch(postNationalIdCategory(newCategoryData));
    }
  };
  // Handle Cancel button click
  const handleCancel = () => {
    setSelectedView("nationalIdList");
  };
  const handleIdentityTypeVi = (e) => {
    const newValue = e.target.value;
    if (newValue.startsWith(" ")) {
      return;
    }

    if (newValue.length > 100) {
      console.error("Input exceeds 100 characters");
      return;
    }

    setCategoryTitlevi(newValue);
  };
  const handleInsuranceCategoryChange = (countryId) => {
    handleSelectCountry(countryId);
  };
  const handleIdentityType = (e) => {
    const newValue = e.target.value;
    if (newValue.startsWith(" ")) {
      return;
    }

    if (newValue.length > 100) {
      console.error("Input exceeds 80 characters");
      return;
    }

    setCategoryTitle(newValue);
  };
  const isDuplicateTitle = allNationalId?.data?.categories.some((category) => (category.title === categoryTitle || category.title === categoryTitlevi) && category.country._id === nationality);
  console.log(isDuplicateTitle);
  return (
    <div className="department-box article-box">
      <Widgets.BreadCrumb
        breadcrumbs={[`${t("identificationType")}`, `${t("addIdentofication")}`]}
        paths={[{ onClick: () => setSelectedView("nationalIdList"), text: strings.navigation.nationalID }]}
      />
      <div className="department-heading">{t("createIdentofication")}</div>
      <div className="NationalId-Input-Box">
        <div className="input-div-identification">
          <div>
            <p className="addNational-title">
              {t("identificationTitle")}
              <span className="asterik">*</span>
            </p>
            <input type="text" placeholder={t("enterIdentityType")} value={categoryTitle} onChange={handleIdentityType} />
          </div>
          <div>
            <p className="addNational-title">
              {t("identificationTitlevi")}
              <span className="asterik">*</span>
            </p>
            <input type="text" placeholder={t("enterIdentityType")} value={categoryTitlevi} onChange={handleIdentityTypeVi} />
          </div>
        </div>

        <p className="addNational-title">
          {t("identityCategory")}
          <span className="asterik">*</span>
        </p>
        {/* <div className="custom-dropdown" onClick={toggleDropdown} ref={dropdownRef}>
  <div className="dropdown-selected">
    {nationality ? countries?.find(country => country._id === nationality)?.name : `${t("selectIdentificationCategory")}`}
    <span className={`dropdown-arrow ${dropdownOpen ? "open" : ""}`}>&#9662;</span> 
  </div>
  {dropdownOpen && (
    <div className="dropdown-options">
      {countries?.map((country) => (
        <div
          key={country._id}
          className="dropdown-option"
          onClick={() => handleSelectCountry(country._id)}
        >
          {country.name}
        </div>
      ))}
    </div>
  )}
</div> */}
        <div className="identity-dropdown">
          <Widgets.SelectDropdown
            options={options}
            selectedValue={nationality ? countries?.find((country) => country._id === nationality)?.name : ""}
            placeholder={t("selectIdentificationCategory")}
            onChange={(selectedOption) => {
              const selectedCountry = countries?.find((country) => country.name === selectedOption);
              handleInsuranceCategoryChange(selectedCountry?._id);
            }}
            big
          />
        </div>

        {newCategoryErr && <p className="error-message">{newCategoryErr}</p>}
        <div className="nation-action">
          <button className="cancel-btn" onClick={handleCancel}>
            {t("cancel")}
          </button>
          <button onClick={handleSubmit} disabled={loading} className="submit-btn">
            {loading ? "Submitting..." : t("submit")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNationalIdList;
